module.exports = __webpack_public_path__ + "img/cart-empty.0ef0565e.png";